<template lang="html">
  <header id="header">
    <div class="box-content">
      <div class="box-top">
        <div class="container oversized-container">
          <div class="b-phones" data-aos="fade" data-aos-delay="150">
            <i class="fas fa-phone icon"></i>
            <span>(33) 3135 3454</span>
            <span>(33) 3135 3453</span>
          </div>
          <div class="b-email" data-aos="fade" data-aos-delay="300">
            <i class="fas fa-envelope icon"></i> <span>ventas@procesosplasticos.com.mx</span>
          </div>
        </div>
      </div>

      <div class="box-menu">
        <b-navbar toggleable="lg" type="light" variant="light">
          <div class="container oversized-container">
            <b-navbar-brand data-aos="fade" data-aos-delay="150" to="/">
              <img src="public/images/logo.svg">
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"><i class="fas fa-bars"></i></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                <b-nav-item class="simple-item" data-aos="fade" data-aos-delay="100" to="/">Inicio</b-nav-item>
                <b-nav-item class="simple-item" data-aos="fade" data-aos-delay="200" to="/productos">Productos</b-nav-item>
                <b-nav-item class="simple-item" data-aos="fade" data-aos-delay="300" to="/historia">Historia</b-nav-item>
                <b-nav-item class="simple-item" data-aos="fade" data-aos-delay="400" to="/galeria">Galería</b-nav-item>
                <b-nav-item class="simple-item" data-aos="fade" data-aos-delay="5000" to="/mercado">Mercado</b-nav-item>
                <b-nav-item class="simple-item" data-aos="fade" data-aos-delay="600" to="/ventajas">Ventajas</b-nav-item>
                <b-nav-item class="simple-item" data-aos="fade" data-aos-delay="700" to="/contacto">Contacto</b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </div>
        </b-navbar>
      </div>
    </div>
  </header>
</template>

<script>
export default {
}
</script>
